import { config } from '@/config';

type Listener = (token: string | null) => void;
const listeners = new Set<Listener>();

let cached: string | null = null;
let loaded = false;

const load = (): string | null => {
  if (loaded) return cached;
  loaded = true;
  try { cached = localStorage.getItem(config.storage.tokenKey); } catch { cached = null; }
  return cached;
};

export const tokenStore = {
  get(): string | null { return load(); },

  set(token: string | null): void {
    cached = token;
    loaded = true;
    try {
      if (token) localStorage.setItem(config.storage.tokenKey, token);
      else localStorage.removeItem(config.storage.tokenKey);
    } catch { /* private mode */ }
    listeners.forEach(l => l(token));
  },

  clear(): void { this.set(null); },

  subscribe(fn: Listener): () => void {
    listeners.add(fn);
    return () => listeners.delete(fn);
  },
};
